module.exports = __webpack_public_path__ + "img/payroll.54e37a91.svg";